<template>
  <div class="teacher">
    <Form ref="optionForm" :model="searchCondition" :label-width="70" inline>
      <FormItem label="讲师名称">
        <Input
          v-model="searchCondition.real_name"
          placeholder="请输入讲师关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          type="number"
          v-model="searchCondition.mobile"
          placeholder="请输入手机号"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="审核状态">
        <Select v-model="searchCondition.approval_status" style="width:200px;">
          <Option v-for="item in approvalStatus" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right">新增讲师</Button>
      <Button type="primary" @click="onImport()" class="btn-margin-right">批量导入</Button>
      <Button type="primary" @click="onExport('all')" class="btn-margin-right">批量导出</Button>
      <Button type="primary" @click="onWatch" class="btn-margin-right">查看报表</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/teacher"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span v-text="row.real_name"></span>
          </div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onApproval(row)">审核</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDetail(row)">详情</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onEdit(row)">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onResetPwd(row)">重置密码</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" type="text" @click="onDelete('select')">删除所选</Button>
          <Button class="btn-margin-right" type="text" @click="onExport('select')">导出所选</Button>
        </template>
      </Grid>
    </div>
    <ExportsModal
      title="导出讲师"
      :type="2"
      :params="exportForm"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></ExportsModal>
    <Modal v-model="approvalModal.show" title="处理审核">
      <Form
        v-if="approvalModal.row"
        ref="approvalModalForm"
        :model="approvalModal.form"
        :rules="approvalModal.formRules"
        :label-width="90"
      >
        <FormItem label="讲师：">
          <div class="vmiddle">
            <img class="table-avatar" :src="approvalModal.row.avatar" />
            <span v-text="approvalModal.row.real_name"></span>
          </div>
        </FormItem>
        <FormItem label="手机号：">{{approvalModal.row.mobile}}</FormItem>
        <FormItem label="审核意见：" prop="approval_status">
          <RadioGroup v-model="approvalModal.form.approval_status">
            <Radio label="3">拒绝</Radio>
            <Radio label="2">通过</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注信息：" prop="approval_failed_message">
          <Input
            type="textarea"
            :rows="4"
            v-model="approvalModal.form.approval_failed_message"
            :placeholder="approvalModal.form.approval_status == 2 ? '请输入备注信息，选填' : '请输入拒绝原因，必填'"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="approvalModal.show = false">取消</Button>
        <Button type="primary" size="large" @click="onApprovalOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ExportsModal from "@/components/ExportsModal";
import { ApprovalStatus } from "@/utils/enums";

export default {
  name: "teacher",
  components: {
    ExportsModal
  },
  data() {
    return {
      searchCondition: {
        real_name: "",
        mobile: "",
        approval_status: "",
        init: function() {
          this.real_name = "";
          this.mobile = "";
          this.approval_status = "";
        }
      },
      tableColumns: [
        { title: "讲师名称", slot: "c1", minWidth: 200 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 150 },
        { title: "所属分类", key: "classify_name", align: "center", minWidth: 150 },
        { title: "课程", key: "count", align: "center", minWidth: 100 },
        {
          title: "审核状态",
          key: "approvalStatusName",
          align: "center",
          minWidth: 100
        },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right"
        }
      ],
      selectRows: [],
      showExportModal: false,
      exportForm: {},
      teacher_default_pass: "",
      approvalStatus: ApprovalStatus.getOptions(),
      approvalModal: {
        show: false,
        row: null, // 需要审核的老师信息行
        form: {
          approval_status: "",
          approval_failed_message: ""
        },
        formRules: {
          approval_status: [
            { required: true, message: "请选择审核意见", trigger: "blur" }
          ]
        }
      }
    };
  },
  created() {
    this.$http.get("/api/commonSetting").then(data => {
      this.teacher_default_pass = data.teacher_default_pass;
    });
  },
  methods: {
    // on-event
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.updated_at = this.$pub.timestampToTime(i.updated_at);
        i.approvalStatusName = ApprovalStatus.getValue(i.approval_status);
        i.classify_name = (i.classify && i.classify.title) || '暂无分类';
      });
    },
    onSelectionChange(items) {
      this.selectRows = items;
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onAdd() {
      this.$router.push({
        name: "TeacherEdit"
      });
    },
    onImport() {
      this.$router.push({
        name: "TeacherImports",
        query: {
          type: "teacher"
        }
      });
    },
    onExport(row) {
      if (row == "select") {
        if (this.selectRows.length == 0) {
          this.$Message.info("请选择要导出的讲师");
          return;
        }
        const idAry = [];
        this.selectRows.forEach(i => {
          idAry.push(i.id);
        });
        this.exportForm.id = idAry.join();
      } else if (row == "all") {
        this.exportForm.real_name = this.searchCondition.real_name;
        this.exportForm.mobile = this.searchCondition.mobile;
        this.exportForm.approval_status = this.searchCondition.approval_status;
      }
      this.showExportModal = true;
    },
    onWatch() {
      this.$router.push({
        name: "TeacherExports",
        query: {
          type: "teacher"
        }
      });
    },
    onApproval(row) {
      this.approvalModal.show = true;
      this.approvalModal.row = row;
      this.approvalModal.form.approval_status =
        (row.approval_status == 2 ? 2 : 3) + "";
      this.approvalModal.form.approval_failed_message =
        row.approval_failed_message || "";
    },
    onDetail(row) {
      this.$router.push({
        name: "TeacherDetail",
        query: {
          id: row.id
        }
      });
    },
    onEdit(row) {
      this.$router.push({
        name: "TeacherEdit",
        query: {
          id: row.id
        }
      });
    },
    onResetPwd(row) {
      this.$Modal.confirm({
        title: "提示",
        content:
          "密码将重置为" +
          this.teacher_default_pass +
          "，请提醒用户及时修改密码。",
        onOk: () => {
          this.$http.put("/api/teacher/resetPwd/" + row.id).then(() => {
            this.$Message.success("密码重置成功！");
          });
        }
      });
    },
    onDelete(row) {
      let ids = "";
      if (row == "select") {
        if (this.selectRows.length == 0) {
          this.$Message.info("请选择要删除的讲师");
          return;
        }
        const idAry = [];
        this.selectRows.forEach(i => {
          idAry.push(i.id);
        });
        ids = idAry.join();
      } else {
        if (row.count > 0) {
          this.$Modal.info({
            title: "提示",
            content: "当前讲师下有课程，无法删除"
          });
          return;
        }
        ids = row.id;
      }
      this.$Modal.confirm({
        title: "提示",
        content: "确定要删除选定讲师吗？",
        onOk: () => {
          this.$http.delete("/api/teacher/" + ids).then(() => {
            this.$Message.success("删除成功");
            this.$refs.grid.refresh();
          });
        }
      });
    },
    onApprovalOk() {
      // 如果是审核拒绝，先判断是否填写了原因
      if (
        this.approvalModal.form.approval_status == 3 &&
        !this.approvalModal.form.approval_failed_message
      ) {
        this.$Message.warning("请输入拒绝原因");
        return;
      }
      this.$refs.approvalModalForm.validate(valid => {
        if (!valid) return;
        this.$http
          .put(
            `/api/teacher/verify/${this.approvalModal.row.id}`,
            this.approvalModal.form
          )
          .then(() => {
            this.$Message.success("操作成功");
            this.approvalModal.show = false;
            setTimeout(() => {
              this.$refs.grid.refresh();
            }, 300);
          });
      });
    }
    // request
  }
};
</script>
